var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "source-doctor-selector"
  }, [_c('label', {
    staticClass: "text-primary text-small tw-mb-2 tw-block"
  }, [_vm._v("Source Doctor")]), _c('div', {
    staticClass: "tw-flex tw-items-center tw-gap-4"
  }, [_c('b-avatar', {
    staticClass: "tw-shrink-0",
    attrs: {
      "size": "36",
      "text": _vm.selectedDoctor ? _vm.selectedDoctor.firstname[0] + _vm.selectedDoctor.lastname[0] : ''
    }
  }), _c('div', {
    staticClass: "tw-flex-1"
  }, [_c('v-select', {
    staticClass: "name-select",
    attrs: {
      "options": _vm.doctorOptions,
      "loading": _vm.loadingDoctors,
      "reduce": opt => opt.value,
      "filter-by": _vm.filterDoctor,
      "label": "label",
      "placeholder": "Search for a doctor..."
    },
    on: {
      "input": _vm.onSelect
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function (opt) {
        return [_c('span', [_vm._v(_vm._s(opt.label))]), opt.inactive ? _c('b-badge', {
          staticClass: "tw-ml-2 tw-text-xs",
          attrs: {
            "variant": "secondary"
          }
        }, [_vm._v(" Inactive ")]) : _vm._e()];
      }
    }, {
      key: "selected-option",
      fn: function (opt) {
        return [_c('span', {
          staticClass: "tw-font-medium"
        }, [_vm._v(_vm._s(opt.label))]), opt.inactive ? _c('b-badge', {
          staticClass: "tw-ml-2 tw-text-xs",
          attrs: {
            "variant": "secondary"
          }
        }, [_vm._v(" Inactive ")]) : _vm._e()];
      }
    }, {
      key: "no-options",
      fn: function () {
        return [_vm._v(" No doctors found. ")];
      },
      proxy: true
    }]),
    model: {
      value: _vm.selectedDoctorId,
      callback: function ($$v) {
        _vm.selectedDoctorId = $$v;
      },
      expression: "selectedDoctorId"
    }
  }), _c('div', {
    staticClass: "text-small tw-mt-1"
  }, [!_vm.selectedDoctorId ? _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(" Panel details will appear here. ")]) : _vm.loadingSummary ? _c('span', {
    staticClass: "text-muted"
  }, [_c('IconLoading', {
    staticClass: "tw-inline tw-size-3"
  }), _vm._v(" Fetching panel counts… ")], 1) : _vm.counts.total === 0 ? _c('span', {
    staticClass: "tw-text-red-500"
  }, [_vm._v(" This doctor has no assigned patients and cannot be used as a source. ")]) : _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(" " + _vm._s(_vm.formatNumber(_vm.counts.total)) + " total · " + _vm._s(_vm.formatNumber(_vm.counts.active)) + " active · " + _vm._s(_vm.formatNumber(_vm.counts.owned)) + " owned · " + _vm._s(_vm.formatNumber(_vm.counts.covering)) + " covering · Licensed in " + _vm._s(_vm.counts.licensedStates) + " states ")])])], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };